import React from "react"
import Seo from "../components/seo"
import { StaticImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import ClientCarousel from "../components/ClientCarousel"
import NavigationBar from "../components/NavigationBar"
import ContactBox from "../components/ContactBox"
import Footer from "../components/Footer"
import CookiesModal from "../components/CookiesModal"

import "./index.scss"

import imgCreativeLab from "../images/fca-backgrounds/creativelab.png"
import imgImplementation from "../images/fca-backgrounds/implementation.png"
import imgContinuousOperation from "../images/fca-backgrounds/continuousoperation.png"

const NearshoreData = [
  [
    {
      title: 'Resuelve tus requerimientos inmediatos',
      description: 'con nuestros desarrolladores o construya con nosotros una relación a largo plazo con una estrategia de análitica creada especialmente para usted.'
    },
    {
      title: 'La mejor ubicación para nearshore,',
      description: 'zona horaria y vuelos directos a las principales ciudades de EE.UU. y Canadá.'
    },
    {
      title: 'Mejores tarifas para análitica',
      description: 'con nuestros consultores certificados.'
    }
  ],
  [
    {
      title: 'Workshops on site',
      description: 'en las instalaciones de los clientes están siempre disponibles con nuestro equipo de expertos.'
    },
    {
      title: 'Equipo ejecutivo y de ventas',
      description: 'en ubicaciones específicas en los EE. UU.'
    },
    {
      title: 'Afinidad cultural',
      description: 'que hacen que los equipos trabajen con el mejor compromiso.'
    }
  ]
]

const ServiceData = [
  {
    title: 'Data Creation',
    link: '/data-creation',
    description: [
      'Plataformas transaccionales para captura y creación de datos',
      'Digitalización',
      'Transformación digital',
      'Modernización de procesos enfocado en el usuario y los datos'
    ]
  },
  {
    title: 'Data Integration',
    link: '/data-integration',
    description: [
      'Integración de fuentes sin importar su localización',
      'Creación, modelado, automatización',
      'Data Warehouse',
      'Data Lakes',
      'Data Lakehouse',
      'Scrapping',
      'Robotización',
      'Integración con API’s',
      'Agnósticos en ETL',
      'Gobernabilidad de datos desde el proceso integrador'
    ]
  },
  {
    title: 'Data Analytics',
    link: '/data-analytics',
    description: [
      'Explotación de analítica para alcanzar objetivos de negocio.',
      'Desarrollo enfocado en el usuario final.',
      'Análisis guiados',
      'Autoservicio',
      'Analítica avanzada y data science',
      'Inteligencia artificial',
      'Machine learning',
    ]
  },
  {
    title: 'Data Sharing',
    link: '/data-sharing',
    description: [
      'Operacionalizar y automatizar decisiones.',
      'Comunicación inter-sistemas entre analítica y transaccionales',
      'Crear insights predictivos accionables '
    ]
  },
  {
    title: 'Data Culture',
    link: '/data-culture',
    description: [
      'Metodologías de Data Culture',
      'Incentivar el uso de datos para la toma de decisiones y en el día a día profesional',
      'Comunicarse efectivamente con datos.'
    ]
  }
]

const SuccessStoriesData = [
  {
    name: 'gray',
    title: 'GRAY',
    phrase: `"Probablemente sean una de las empresas más fuertes que podrías contratar a nivel mundial para Qlik."`
  },
  {
    name: 'bimbo',
    title: 'BIMBO',
    phrase: `"Proyectos Globales, gobernados de manera correcta, con arquitectura en la nube que generan Insights para nuestra toma de decisiones."`
  },
  {
    name: 'bmw',
    title: 'BMW',
    phrase: `"Poniendo la muestra para todo corporativo con nuestros proyectos de Qlik, integrando nuestras diferentes plataformas en un solo portal."`
  },
  {
    name: 'hsbc',
    title: 'HSBC',
    phrase: `"Con proyectos de Business Intelligence y Machine Learning, cambiaremos la manera de operar el Data Center de HSBC."`,
  },
  {
    name: 'laeuropea',
    title: 'LA EUROPEA',
    phrase: `"Portales para nuestros proveedores, sucursales y Clientes para toma decisiones que nos convertirán en una empresa democratizada por datos."`
  },
  {
    name: 'heb',
    title: 'HEB',
    phrase: `"Siempre generando innovación y valor para la toma de decisiones con la evolución de Qlik desde hace 8 años."`
  }
]

const HowWeDoItData = [
  {
    title: 'Creative Lab',
    img: imgCreativeLab,
    desc: `Nuestro negocio creativo especializado en guiar el proceso de diseño de soluciones`,
    list: [
      'Business Discovery Workshop',
      'Discovery Process',
      'Data Science On Demand',
      'R & D',
      'UX / UI'
    ]
  },
  {
    title: 'Implementation',
    img: imgImplementation,
    desc: `Nuestro equipo experto, procesos y metodologías para hacer de una solución una realidad`,
    list: [
      'Projects',
      'Outsourcing',
      'Near Shore',
      'Off Shore',
      'Agile'
    ]

  },
  {
    title: 'Continuous Operation',
    img: imgContinuousOperation,
    desc: `¿Cómo quieres llevar la solución?. Nosotros tenemos muchas opciones`,
    list: [
      'Business Intelligence As A Service',
      'Data Science As A Service',
      'Cloud (AWS, Azure, Google)',
      'Hypercare',
      'Support'
    ]

  }
]

const LandingDescription = () => (
  <p className="description">
    Empoderamos a las empresas y a las personas para liberar el valor de los datos en sus organizaciones. Lo hacemos a través de la implementación de procesos y plataformas de analítica,  con un enfoque que cubre el ciclo completo que necesitan llevar a cabo para lograrlo.
    <br />
    <a href="#howwedoit"><span className="text-strong">Full-Cycle Analytics.</span></a>
  </p>
)

const HowWeDoItStep = ({ title, img, number, list, desc }) => (
  <div>
    <div className="number">
      <svg xmlns="http://www.w3.org/2000/svg">
        <text textAnchor="middle" dominantBaseline="middle" x="50%" y="50%">
          <tspan>{number}</tspan>
        </text>
      </svg>
    </div>
    <div className="step-content">
      <div className="image" style={{ backgroundImage: `url(${img})` }}>
        <h2 className="title">{title}</h2>
      </div>
      <div className="text">
        <div className="desc">
          <p>{desc}</p>
        </div>
        <ul className="list text-weak">
          {list.map(i => <li key={i}>{i}</li>)}
        </ul>
      </div>
    </div>
  </div>
)

const HomeSection = () => (
  <section className="fullscreen only-desktop" id="home">
    <div className="content">
      <div className="principal-content">
        <div className="text-content">
          <h1 className="text-slogan">
            <span className="box">
              <span className="small">release </span><span>the </span>
            </span>
            <span className="box">
              <span className="big">power </span>
              <span><span>of </span><span>data</span></span>
            </span>
          </h1>
          <LandingDescription />
        </div>
        <div className="devices">
          <StaticImage src="../images/devices.png" alt="Devices"/>
        </div>
        <div className="description-mobile">
          <LandingDescription />
        </div>
      </div>
    </div>
    <div className="arc"></div>
  </section>
)

const AboutUsSection = () => (
  <section id="aboutus">
    <div className="content">
      <div className="principal-content">
        <div className="description">
          <h2 className="title">+ 10 años</h2>
          <p className="text-bold">Siendo el aliado de nuestros clientes para impulsar el cambio en sus organizaciones usando datos.</p>
          <p>Creamos plataformas analíticas, servicios y experiencias que transforman la manera en que las compañías generan valor con su información.</p>
          <p>Una propuesta que se sustenta con equipos multidisciplinarios perfectamente integrados y con alianzas robustas con los mejores proveedores de tecnología.</p>
          <div className="align-center">
            <iframe title="about us video" className="youtube-video" width="448" height="252" src="https://www.youtube.com/embed/N8WW-xNx9d8" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          </div>
          <p>Con esta combinación hacemos realidad las ideas mas disruptivas.</p>
          <div className="align-center">
            <Link to="/aboutus">
              <span className="button primary">Ver más acerca de nosotros</span>
            </Link>
          </div>
        </div>
        <div className="clients">
          <span>Ganamos a través del éxito de nuestros clientes</span>
          <ClientCarousel />
        </div>
      </div>
      <div className="title-banner">
        <div className="carousel">
          <span>Nosotros</span>
          <span>Nosotros</span>
        </div>
      </div>
    </div>
  </section>
)

const NearshoreSection = () => (
  <section id="nearshore">
    <div className="content">
      <div className="principal-content">
        <div className="title">
          <h1>El <span className="bold">nearshore</span> como nunca lo has experimentado</h1>
          <span>Nuestros proyectos son desarrollados con equipos globales enfocados en generar valor sustentable para nuestros clientes.</span>
        </div>
        <div className="video">
          <iframe title="nearshore video" className="youtube-video" width="448" height="252" src="https://www.youtube.com/embed/rDUOkznCMuw" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
        </div>
        <div className="map">
          <StaticImage src="../images/nearshore.png" alt="map"/>
        </div>
        <div className="bullets">
          {
            NearshoreData.map((arr, index) => (
              <div key={index}>
                <ul>
                  {
                    arr.map(i => (
                      <li key={i.title}>
                        <div className="bullet-title">
                          <span>{i.title}</span>
                        </div>
                        <div className="bullet-description">
                          <span>{i.description}</span>
                        </div>
                      </li>
                    ))
                  }
                </ul>
              </div>
            ))
          }
        </div>
        <div className="actions"></div>
      </div>
    </div>
  </section>
)

const ServicesSection = () => (
  <section id="services">
    <div className="content">
      <div className="title navigationbar-space">
        <h1>Nuestros Servicios</h1>
      </div>
      <div className="principal-content">
        <ul className="list">
          {
            ServiceData.map(i => (
              <li key={i.title} className="card">
                <div className="card-img"></div>
                <div className="card-content">
                  <span className="name">{i.title}</span>
                  <div className="description">
                    <ul>
                      {
                        i.description.map(ii => <li key={ii}>{ii}</li>)
                      }
                    </ul>
                  </div>
                </div>
                <div className="card-footer">
                  <Link to={i.link}><span className="link">Ver más</span></Link>
                </div>
              </li>
            ))
          }
        </ul>
      </div>
    </div>
  </section>
)

const PlatformsSection = () => (
  <section id="platforms">
    <div className="content">
      <div className="principal-content">
        <div className="title">
          <h1>Contamos con los <span className="bold">MEJORES SOCIOS</span></h1>
        </div>
        <div className="platforms">
          <div>
            <div>
              <span>Data Integration</span>
            </div>
            <div>
              <Link to="/data-integration">
                <StaticImage src="../images/platform-icons/azure-data-factory.png" alt="logo azure data factory"/>
              </Link>
              <Link to="/azure-synapse">
                <StaticImage src="../images/platform-icons/azure-synapse.png" height={54} alt="logo azure synapse analytics"/>
              </Link>
              <Link to="/data-integration">
                <StaticImage src="../images/platform-icons/databricks.png" height={48} alt="logo data bricks"/>
              </Link>
              <Link to="/data-integration">
                <StaticImage src="../images/platform-icons/qlik-qdi.png" height={48} alt="logo qlik qdi"/>
              </Link>
              <Link to="/snowflake">
                <StaticImage src="../images/platform-icons/snowflake.png" alt="logo snowflake"/>
              </Link>
            </div>
          </div>
          <div>
            <div>
              <span>Data Analytics</span>
            </div>
            <div>
              <Link to="/qlik">
                <StaticImage src="../images/platform-icons/qlik.png" height={36} alt="logo qlik"/>
              </Link>
              <Link to="/tableau">
                <StaticImage src="../images/platform-icons/tableau.png" height={36} alt="logo tableau"/>
              </Link>
              <Link to="/powerbi">
                <StaticImage src="../images/platform-icons/powerbi.png" height={36} alt="logo powerbi"/>
              </Link>
              <Link to="/">
                <StaticImage src="../images/platform-icons/vizlib.png" height={34} alt="logo vizlib"/>
              </Link>
              <Link to="/">
                <StaticImage src="../images/platform-icons/evoaccess.png" alt="logo evo access"/>
              </Link>
            </div>
          </div>
          <div>
            <div>
              <span>Data Science</span>
            </div>
            <div>
              <Link to="/data-analytics">
                <StaticImage src="../images/platform-icons/rapidminer.png" height={48} alt="logo rapidminer"/>
              </Link>
              <Link to="/data-analytics">
                <StaticImage src="../images/platform-icons/knime.png" height={34} alt="logo knime"/>
              </Link>
              <Link to="/data-analytics">
                <StaticImage src="../images/platform-icons/python.png" height={34} alt="logo python"/>
              </Link>
            </div>
          </div>
          <div>
            <div>
              <span>Hosting Services</span>
            </div>
            <div>
              <Link to="/data-integration">
                <StaticImage src="../images/platform-icons/aws.png" height={40} alt="logo aws"/>
              </Link>
              <Link to="/data-integration">
                <StaticImage src="../images/platform-icons/azure.png" height={44} alt="logo azure"/>
              </Link>
              <Link to="/data-integration">
                <StaticImage src="../images/platform-icons/googlecloud.png" alt="logo google cloud"/>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
)

const SuccessStoriesSection = () => (
  <section id="successstories">
    <div className="content">
      <div className="principal-content">
        <div className="title">
          <h2>Creando impacto.</h2>
          <h3>Casos de éxito</h3>
        </div>
        <div className="cards">
          {
            SuccessStoriesData.map(i => (
              <div key={i.name} className={['card', i.name].join(' ')}>
                <div className="title">
                  <div className="icon"></div>
                </div>
                <div className="phrase">
                  <span>{i.phrase}</span>
                </div>
                <div className="from">
                  <span></span>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  </section>
)

const HowWeDoItSection = () => (
  <section id="howwedoit">
    <div className="content">
      <div className="principal-content">
        <div className="title">
          <h2>¿Cómo lo hacemos?</h2>
          <p>
            <span className="bold">Conocemos su negocio: </span><br />
            Nosotros nos dedicaremos a entender y conocer tu negocio, su filosofía, motivaciones y dolores. Y con esto, poder proponer soluciones de analítica que les ayude a tomar decisiones.<br />
            Nuestra metodología de 3 fases ayuda a convertir la resistencia natural de todo proyecto en motivación.<br />
          </p>
          <h3>Full-Cycle Analytics</h3>
        </div>
        <div className="description">
          {
            HowWeDoItData.map((i, index) => <HowWeDoItStep key={i.title} title={i.title} img={i.img} number={index + 1} list={i.list} desc={i.desc} />)
          }
        </div>
      </div>
    </div>
  </section>
)

const IndexPage = () => (
  <>
    <NavigationBar theme="dark" customTheme={[
      { id: 'home', theme: 'dark' },
      { id: 'aboutus', theme: 'light' },
      { id: 'nearshore', theme: 'light' },
      { id: 'services', theme: 'light' },
      { id: 'platforms', theme: 'light' },
      { id: 'successstories', theme: 'light' },
      { id: 'howwedoit', theme: 'dark' }
    ]} />

    <HomeSection />
    <AboutUsSection />
    <NearshoreSection />
    <ServicesSection />
    <PlatformsSection />
    <SuccessStoriesSection />
    <HowWeDoItSection />

    <ContactBox />
    <Footer />
    <CookiesModal />
  </>
)

export default IndexPage

export const Head = () => <Seo title="Home"/>